module.exports = __webpack_public_path__ + "img/icon_qusetion.9c8b1599.svg";